// @ts-ignore
import { CACHE_ID } from './cache.cjs';

export const getOldCacheNames = async () => {
  const cacheNames = (await window.caches.keys()) || [];
  return cacheNames.filter((cacheName) => {
    return cacheName !== 'start-url' && !cacheName.startsWith(CACHE_ID);
  });
};

export const clearOldCaches = async (): Promise<string[]> => {
  try {
    const oldCacheNames = await getOldCacheNames();

    await Promise.all(
      oldCacheNames.map((cacheName) => {
        return window.caches.delete(cacheName);
      })
    );

    return oldCacheNames;
  } catch (error) {
    console.log('@cache@errors', error);
    return [];
  }
};
